import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCmsElectricianCommentForm, LazyCmsElectricianCommentList, LazyCmsElectricianNote, LazyCmsElectricianProfile, LazyLayoutNavbar, LazyLayoutSidebar, LazyLayoutSidebarMenu, LazyLayoutSidebarNavigation, LazyUiAlert, LazyUiAlertDescription, LazyUiAlertTitle, LazyUiAlertDialogAction, LazyUiAlertDialog, LazyUiAlertDialogCancel, LazyUiAlertDialogContent, LazyUiAlertDialogDescription, LazyUiAlertDialogFooter, LazyUiAlertDialogHeader, LazyUiAlertDialogOverlay, LazyUiAlertDialogPortal, LazyUiAlertDialogTitle, LazyUiAlertDialogTrigger, LazyUiAvatar, LazyUiAvatarFallback, LazyUiAvatarImage, LazyUiBadge, LazyUiBarcode, LazyUiBreadcrumbs, LazyUiButton, LazyUiCard, LazyUiCardContent, LazyUiCardDescription, LazyUiCardFooter, LazyUiCardHeader, LazyUiCardTitle, LazyUiCheckbox, LazyUiCheckboxIndicator, LazyUiContainer, LazyUiDatatable, LazyUiDateField, LazyUiDatepicker, LazyUiDebug, LazyUiDropdownMenuArrow, LazyUiDropdownMenuCheckboxItem, LazyUiDropdownMenuContent, LazyUiDropdownMenu, LazyUiDropdownMenuGroup, LazyUiDropdownMenuItem, LazyUiDropdownMenuItemIndicator, LazyUiDropdownMenuLabel, LazyUiDropdownMenuPortal, LazyUiDropdownMenuRadioGroup, LazyUiDropdownMenuRadioItem, LazyUiDropdownMenuSeparator, LazyUiDropdownMenuShortcut, LazyUiDropdownMenuSub, LazyUiDropdownMenuSubContent, LazyUiDropdownMenuSubTrigger, LazyUiDropdownMenuTrigger, LazyUiEmpty, LazyUiFancyIcon, LazyUiHeading, LazyUiInput, LazyUiLabel, LazyUiLine, LazyUiLoader, LazyUiNativeSelect, LazyUiPhoneInput, LazyUiRating, LazyUiScrollAreaCorner, LazyUiScrollArea, LazyUiScrollAreaScrollbar, LazyUiScrollAreaThumb, LazyUiScrollAreaViewport, LazyUiSelectArrow, LazyUiSelectContent, LazyUiSelectGroup, LazyUiSelectIcon, LazyUiSelectItem, LazyUiSelectItemIndicator, LazyUiSelectItemText, LazyUiSelectLabel, LazyUiSelectPortal, LazyUiSelectScrollDownButton, LazyUiSelectScrollUpButton, LazyUiSelect, LazyUiSelectSeparator, LazyUiSelectTrigger, LazyUiSelectValue, LazyUiSelectViewport, LazyUiTableBody, LazyUiTableCaption, LazyUiTableCell, LazyUiTableEmpty, LazyUiTableFooter, LazyUiTableHead, LazyUiTableHeader, LazyUiTableRow, LazyUiTable, LazyUiTabsContent, LazyUiTabsIndicator, LazyUiTabsList, LazyUiTabs, LazyUiTabsTrigger, LazyUiTagsInputClear, LazyUiTagsInputField, LazyUiTagsInputItem, LazyUiTagsInputItemDelete, LazyUiTagsInputItemText, LazyUiTagsInput, LazyUiTanStackTable, LazyUiTextarea, LazyUiToastAction, LazyUiToastClose, LazyUiToastDescription, LazyUiToastProvider, LazyUiToastTitle, LazyUiToast, LazyUiToastToaster, LazyUiToastViewport, LazyUiTooltipArrow, LazyUiTooltipContent, LazyUiTooltipPortal, LazyUiTooltipProvider, LazyUiTooltip, LazyUiTooltipTrigger, LazyUiVeeDateField, LazyUiVeeDatepicker, LazyUiVeeInput, LazyUiVeeMultiSelect, LazyUiVeePhoneInput, LazyUiVeeSelect, LazyUiVeeTagsInput, LazyUiVeeTextarea, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["CmsElectricianCommentForm", LazyCmsElectricianCommentForm],
["CmsElectricianCommentList", LazyCmsElectricianCommentList],
["CmsElectricianNote", LazyCmsElectricianNote],
["CmsElectricianProfile", LazyCmsElectricianProfile],
["LayoutNavbar", LazyLayoutNavbar],
["LayoutSidebar", LazyLayoutSidebar],
["LayoutSidebarMenu", LazyLayoutSidebarMenu],
["LayoutSidebarNavigation", LazyLayoutSidebarNavigation],
["UiAlert", LazyUiAlert],
["UiAlertDescription", LazyUiAlertDescription],
["UiAlertTitle", LazyUiAlertTitle],
["UiAlertDialogAction", LazyUiAlertDialogAction],
["UiAlertDialog", LazyUiAlertDialog],
["UiAlertDialogCancel", LazyUiAlertDialogCancel],
["UiAlertDialogContent", LazyUiAlertDialogContent],
["UiAlertDialogDescription", LazyUiAlertDialogDescription],
["UiAlertDialogFooter", LazyUiAlertDialogFooter],
["UiAlertDialogHeader", LazyUiAlertDialogHeader],
["UiAlertDialogOverlay", LazyUiAlertDialogOverlay],
["UiAlertDialogPortal", LazyUiAlertDialogPortal],
["UiAlertDialogTitle", LazyUiAlertDialogTitle],
["UiAlertDialogTrigger", LazyUiAlertDialogTrigger],
["UiAvatar", LazyUiAvatar],
["UiAvatarFallback", LazyUiAvatarFallback],
["UiAvatarImage", LazyUiAvatarImage],
["UiBadge", LazyUiBadge],
["UiBarcode", LazyUiBarcode],
["UiBreadcrumbs", LazyUiBreadcrumbs],
["UiButton", LazyUiButton],
["UiCard", LazyUiCard],
["UiCardContent", LazyUiCardContent],
["UiCardDescription", LazyUiCardDescription],
["UiCardFooter", LazyUiCardFooter],
["UiCardHeader", LazyUiCardHeader],
["UiCardTitle", LazyUiCardTitle],
["UiCheckbox", LazyUiCheckbox],
["UiCheckboxIndicator", LazyUiCheckboxIndicator],
["UiContainer", LazyUiContainer],
["UiDatatable", LazyUiDatatable],
["UiDateField", LazyUiDateField],
["UiDatepicker", LazyUiDatepicker],
["UiDebug", LazyUiDebug],
["UiDropdownMenuArrow", LazyUiDropdownMenuArrow],
["UiDropdownMenuCheckboxItem", LazyUiDropdownMenuCheckboxItem],
["UiDropdownMenuContent", LazyUiDropdownMenuContent],
["UiDropdownMenu", LazyUiDropdownMenu],
["UiDropdownMenuGroup", LazyUiDropdownMenuGroup],
["UiDropdownMenuItem", LazyUiDropdownMenuItem],
["UiDropdownMenuItemIndicator", LazyUiDropdownMenuItemIndicator],
["UiDropdownMenuLabel", LazyUiDropdownMenuLabel],
["UiDropdownMenuPortal", LazyUiDropdownMenuPortal],
["UiDropdownMenuRadioGroup", LazyUiDropdownMenuRadioGroup],
["UiDropdownMenuRadioItem", LazyUiDropdownMenuRadioItem],
["UiDropdownMenuSeparator", LazyUiDropdownMenuSeparator],
["UiDropdownMenuShortcut", LazyUiDropdownMenuShortcut],
["UiDropdownMenuSub", LazyUiDropdownMenuSub],
["UiDropdownMenuSubContent", LazyUiDropdownMenuSubContent],
["UiDropdownMenuSubTrigger", LazyUiDropdownMenuSubTrigger],
["UiDropdownMenuTrigger", LazyUiDropdownMenuTrigger],
["UiEmpty", LazyUiEmpty],
["UiFancyIcon", LazyUiFancyIcon],
["UiHeading", LazyUiHeading],
["UiInput", LazyUiInput],
["UiLabel", LazyUiLabel],
["UiLine", LazyUiLine],
["UiLoader", LazyUiLoader],
["UiNativeSelect", LazyUiNativeSelect],
["UiPhoneInput", LazyUiPhoneInput],
["UiRating", LazyUiRating],
["UiScrollAreaCorner", LazyUiScrollAreaCorner],
["UiScrollArea", LazyUiScrollArea],
["UiScrollAreaScrollbar", LazyUiScrollAreaScrollbar],
["UiScrollAreaThumb", LazyUiScrollAreaThumb],
["UiScrollAreaViewport", LazyUiScrollAreaViewport],
["UiSelectArrow", LazyUiSelectArrow],
["UiSelectContent", LazyUiSelectContent],
["UiSelectGroup", LazyUiSelectGroup],
["UiSelectIcon", LazyUiSelectIcon],
["UiSelectItem", LazyUiSelectItem],
["UiSelectItemIndicator", LazyUiSelectItemIndicator],
["UiSelectItemText", LazyUiSelectItemText],
["UiSelectLabel", LazyUiSelectLabel],
["UiSelectPortal", LazyUiSelectPortal],
["UiSelectScrollDownButton", LazyUiSelectScrollDownButton],
["UiSelectScrollUpButton", LazyUiSelectScrollUpButton],
["UiSelect", LazyUiSelect],
["UiSelectSeparator", LazyUiSelectSeparator],
["UiSelectTrigger", LazyUiSelectTrigger],
["UiSelectValue", LazyUiSelectValue],
["UiSelectViewport", LazyUiSelectViewport],
["UiTableBody", LazyUiTableBody],
["UiTableCaption", LazyUiTableCaption],
["UiTableCell", LazyUiTableCell],
["UiTableEmpty", LazyUiTableEmpty],
["UiTableFooter", LazyUiTableFooter],
["UiTableHead", LazyUiTableHead],
["UiTableHeader", LazyUiTableHeader],
["UiTableRow", LazyUiTableRow],
["UiTable", LazyUiTable],
["UiTabsContent", LazyUiTabsContent],
["UiTabsIndicator", LazyUiTabsIndicator],
["UiTabsList", LazyUiTabsList],
["UiTabs", LazyUiTabs],
["UiTabsTrigger", LazyUiTabsTrigger],
["UiTagsInputClear", LazyUiTagsInputClear],
["UiTagsInputField", LazyUiTagsInputField],
["UiTagsInputItem", LazyUiTagsInputItem],
["UiTagsInputItemDelete", LazyUiTagsInputItemDelete],
["UiTagsInputItemText", LazyUiTagsInputItemText],
["UiTagsInput", LazyUiTagsInput],
["UiTanStackTable", LazyUiTanStackTable],
["UiTextarea", LazyUiTextarea],
["UiToastAction", LazyUiToastAction],
["UiToastClose", LazyUiToastClose],
["UiToastDescription", LazyUiToastDescription],
["UiToastProvider", LazyUiToastProvider],
["UiToastTitle", LazyUiToastTitle],
["UiToast", LazyUiToast],
["UiToastToaster", LazyUiToastToaster],
["UiToastViewport", LazyUiToastViewport],
["UiTooltipArrow", LazyUiTooltipArrow],
["UiTooltipContent", LazyUiTooltipContent],
["UiTooltipPortal", LazyUiTooltipPortal],
["UiTooltipProvider", LazyUiTooltipProvider],
["UiTooltip", LazyUiTooltip],
["UiTooltipTrigger", LazyUiTooltipTrigger],
["UiVeeDateField", LazyUiVeeDateField],
["UiVeeDatepicker", LazyUiVeeDatepicker],
["UiVeeInput", LazyUiVeeInput],
["UiVeeMultiSelect", LazyUiVeeMultiSelect],
["UiVeePhoneInput", LazyUiVeePhoneInput],
["UiVeeSelect", LazyUiVeeSelect],
["UiVeeTagsInput", LazyUiVeeTagsInput],
["UiVeeTextarea", LazyUiVeeTextarea],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
